<p-fieldset [legend]="'orders.setup.orderSummary.additionalContact' | translate" id="order-additional-contact-field">
    <form [formGroup]="additionalContactForm">
        <div id="order-additional-contact-field-content">
            @if (additionalContactForm.controls.isRequesterAccountOwner.enabled) {
                <div id="requester-is-the-same-with-account-owner-container">
                    <p-checkbox
                        id="'additional-contact-requester-the-same-with-account-owner-checkbox'"
                        [binary]="true"
                        (onChange)="selectAccountOwnerAsRequester()"
                        formControlName="isRequesterAccountOwner">
                    </p-checkbox>
                    <label
                        id="additional-contact-requester-the-same-with-account-owner-label"
                        [for]="'additional-contact-requester-the-same-with-account-owner-checkbox'"
                        (click)="changeAccountOwnerRequesterSelection()">
                        {{
                            'orders.setup.orderSummary.additionalContact.isRequesterTheSameWithOwner' | translate
                        }}</label
                    >
                </div>
            }

            <div id="additional-contact-fields-container">
                <div id="additional-contact-requester-field-container">
                    <div class="label-container">
                        <div>
                            <label
                                id="additional-contact-requester-field-label"
                                [for]="'additional-contact-requester-field-dropdown'"
                                >{{ 'orders.requester' | translate }} </label
                            ><span class="p-error">*</span>
                        </div>

                        <app-info-tooltip
                            [id]="'order-summary-requester-info-tooltip'"
                            [tooltipText]="'orders.setup.orderSummary.additionalContact.requester.tooltip'"
                            [iconClass]="'fa-circle-info fa-light'"></app-info-tooltip>
                    </div>

                    <div class="dropdown-container" #requesterContainer>
                        <p-dropdown
                            id="additional-contact-requester-field-dropdown"
                            formControlName="requester"
                            ariaLabelledBy="additional-contact-requester-field-label"
                            [class.ng-dirty]="additionalContactForm.controls.requester.touched"
                            [options]="requesters"
                            [optionLabel]="'fullName'"
                            [optionValue]="'id'"
                            [filter]="true"
                            [filterFields]="['email', 'fullName']"
                            [placeholder]="
                                'orders.setup.orderSummary.additionalContact.requester.placeHolder' | translate
                            "
                            (onChange)="evaluateCheckboxState()">
                            <ng-template let-requester let-index pTemplate="item">
                                <div class="user-item" [ngClass]="index % 2 === 0 ? 'even' : 'odd'">
                                    <p
                                        [id]="'additional-contact-requester-user-name-' + requester.id"
                                        class="user-name">
                                        {{ requester.fullName }}
                                    </p>
                                    <p [id]="'additional-contact-requester-email-' + requester.id" class="user-email">
                                        {{ requester.email }}
                                    </p>
                                </div>
                            </ng-template>
                        </p-dropdown>

                        <ng-container>
                            @if (
                                additionalContactForm.controls.requester.touched &&
                                additionalContactForm.controls.requester.errors?.['required']
                            ) {
                                <p class="p-error">
                                    {{ 'orders.setup.orderSummary.validators.requester' | translate }}
                                </p>
                            }
                        </ng-container>
                    </div>
                </div>

                <div id="additional-contact-informed-user-field-container">
                    <div class="label-container">
                        <div>
                            <label
                                id="additional-contact-informed-user-field-label"
                                [for]="'additional-contact-informed-user-field-dropdown'"
                                >{{ 'orders.informed' | translate }}
                            </label>
                        </div>

                        <app-info-tooltip
                            [id]="'order-summary-informed-user-info-tooltip'"
                            [tooltipText]="'orders.setup.orderSummary.additionalContact.informed.tooltip'"
                            [iconClass]="'fa-circle-info fa-light'"></app-info-tooltip>
                    </div>

                    <div class="dropdown-container" #informedUserContainer>
                        <p-multiSelect
                            id="additional-contact-informed-user-field-dropdown"
                            display="chip"
                            [optionLabel]="'fullName'"
                            [optionValue]="'id'"
                            formControlName="informedUsers"
                            [options]="informedUsers"
                            [placeholder]="'order.list.table.filters.informed.placeholder' | translate"
                            [maxSelectedLabels]="informedUsers.length"
                            [filter]="true"
                            [filterFields]="['fullName', 'email']"
                            [showClear]="true"
                            (click)="informedUsersSelect($event)">
                            <ng-template pTemplate="header">
                                <div id="informed-add-new-user-container">
                                    <p-button
                                        id="informed-user-add-new-user-btn"
                                        [outlined]="true"
                                        [text]="true"
                                        (click)="addNewInformedUser()"
                                        ><i class="fa-regular fa-plus"></i>
                                        <p>
                                            {{
                                                'orders.setup.orderSummary.additionalContact.informed.addNewUser'
                                                    | translate
                                            }}
                                        </p></p-button
                                    >
                                </div>
                            </ng-template>

                            <ng-template let-informed pTemplate="item">
                                <div class="user-item">
                                    <app-ellipsis-tooltip
                                        [paragraphId]="'additional-contact-informed-user-name-' + informed.id"
                                        class="user-name">
                                        {{ informed.fullName }}
                                    </app-ellipsis-tooltip>

                                    <app-ellipsis-tooltip
                                        [paragraphId]="'additional-contact-informed-email-' + informed.id"
                                        class="user-email">
                                        {{ informed.email }}
                                    </app-ellipsis-tooltip>
                                </div>
                            </ng-template>

                            <ng-template pTemplate="empty">
                                <div class="empty-state-container">
                                    <i class="fa-duotone fa-list-dropdown"></i>
                                    <p class="primary-text">
                                        {{
                                            'orders.setup.orderSummary.additionalContact.informed.emptyState.primaryText'
                                                | translate
                                        }}
                                    </p>
                                    <p class="secondary-text">
                                        {{
                                            'orders.setup.orderSummary.additionalContact.informed.emptyState.secondaryText'
                                                | translate
                                        }}
                                    </p>
                                </div>
                            </ng-template>
                        </p-multiSelect>
                    </div>
                </div>
            </div>
        </div>
    </form>
</p-fieldset>
